/**
 * What the shared cover field offers (design cover-editor a1, a2):
 * - `none`: no cover → "Design a cover" (main) and "Upload a file".
 * - `editor`: the cover came from the editor → "Edit cover" (main) and "Replace with a file".
 * - `file`: an uploaded cover or a cover of the stores → "Replace with a file" (main) and
 *   "Design a new cover".
 */
export type CoverFieldState = 'none' | 'editor' | 'file';

/**
 * The state of the cover field. `coverDesignUuid` is the version that is the cover of the song now
 * (the editor answer); `isSavedCover` is false while the field holds a new picture that waits for
 * Save (then the picture on screen is not the one the editor made). Pure.
 */
export function coverFieldState(input: {
  hasCover: boolean;
  coverDesignUuid: string | null | undefined;
  isSavedCover: boolean;
}): CoverFieldState {
  if (!input.hasCover) {
    return 'none';
  }
  const fromEditor = input.coverDesignUuid !== null && input.coverDesignUuid !== undefined;
  return fromEditor && input.isSavedCover ? 'editor' : 'file';
}

/** True when the editor is offered: not in a native app's web view (the apps keep their upload). Pure. */
export function offersCoverEditor(input: { isNativeEmbed: boolean }): boolean {
  return !input.isNativeEmbed;
}
